import * as React from "react";

export const useOnChange = (update: any) => {
  return React.useCallback(
    ({ target: { name: property, value } }: any) => {
      update((s: any) => ({
        ...s,
        [property]: typeof value === "function" ? value(s[property]) : value,
      }));
    },
    [update]
  );
};

export const useOnValueChange = (update: any, property: string) => {
  return React.useCallback(
    (value: any) => {
      update((s: any) => ({
        ...s,
        [property]: typeof value === "function" ? value(s[property]) : value,
      }));
    },
    [update]
  );
};

export const useUpdater = (update: any, prop: string) => {
  return React.useCallback(updater(update, prop), [update]);
};

const updater = (update: any, prop: string) => {
  return (moreState: any) => {
    update((s: any) => {
      s = s || {};
      return {
        ...s,
        [prop]: typeof moreState === "function" ? moreState(s[prop]) : moreState,
      };
    });
  };
};

export const useOnChangeWithError = (update: any, setError: any) => {
  return React.useCallback(
    ({ target: { name: property, value } }: any) => {
      update((s: any) => ({
        ...s,
        [property]: typeof value === "function" ? value(s[property]) : value,
      }));
      setError((e: any) => ({
        ...e,
        [property]: undefined,
      }));
    },
    [update]
  );
};

export function useOnValueChangeWithError<
  R extends Record<string, any>,
  E extends Record<string, any> | undefined = undefined,
  K extends keyof R & (E extends undefined ? never : keyof E) = keyof R &
    (E extends undefined ? never : keyof E)
>(
  update: React.Dispatch<React.SetStateAction<R>>,
  setError: React.Dispatch<React.SetStateAction<E>>,
  property: K
) {
  return React.useCallback(
    (value: R[K] | ((prevValue: R[K]) => R[K])) => {
      update((prevRecord) => ({
        ...prevRecord,
        [property]:
          typeof value === "function"
            ? (value as (prevValue: R[K]) => R[K])(prevRecord[property])
            : value,
      }));

      if (setError) {
        setError((prevErrors) => ({
          ...prevErrors,
          [property]: undefined,
        }));
      }
    },
    [update, setError, property]
  );
}
